import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiLavandierService } from '../../../../../lib/lib-ngx/web-services/api-lavandier.service';
import { ITransportSheet } from '../../../../../lib/lib-shared/models/TransportSheet';
import { ErrorService } from '../../../../../lib/lib-ngx/services/error.service';
import { IHouseDetailsList } from '../../../../../lib/lib-shared/models/House';
import { ConfirmationModalComponent } from '../../../modals/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'lm-user-transport-sheet',
  templateUrl: './user-transport-sheet.component.html',
  styleUrls: ['./user-transport-sheet.component.scss']
})
export class UserTransportSheetComponent implements OnInit {

  @Input() user = null;
  @Input() houseMap: Map<number, IHouseDetailsList> = new Map();
  @Input() lavandierMap = new Map();

  public transportSheetList: ITransportSheet[] = [];
  public editingTransportSheets = new Map<number, number>();

  public form: FormGroup;

  public rowClass = (row: ITransportSheet) => ({'transport-sheet-disabled': !!row.disabledAt});

  constructor(
    private apiLavandierService: ApiLavandierService,
    private fb: FormBuilder,
    private errorService: ErrorService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.loadData();
    this.buildForm();
  }

  loadData() {
    this.apiLavandierService.getTransportSheetUserId(this.user.id, {})
      .subscribe(transportSheetList => {
        this.transportSheetList = transportSheetList;
      });
  }

  buildForm() {
    this.form = this.fb.group({
      ref: [null, Validators.required],
    });
  }

  onAddTransportSheet() {
    this.apiLavandierService.putTransportSheetUserIdBook(this.user.id, {ref: this.form.value.ref})
      .subscribe(data => {
        if (!this.errorService.manageError(data)) {
          this.loadData();
          this.form.controls['ref'].setValue(null);
        }
      });
  }

  startEditAddress(transportSheet: ITransportSheet) {
    this.editingTransportSheets.set(transportSheet.id, transportSheet.houseId);
  }

  confirmAddressChange(transportSheet: ITransportSheet) {
    const selectedHouseId = this.editingTransportSheets.get(transportSheet.id);
    if (!selectedHouseId || selectedHouseId === transportSheet.houseId) {
      this.cancelEdit(transportSheet.id);
      return;
    }

    this.apiLavandierService.putTransportSheetIdHouse(transportSheet.id, {
      houseId: selectedHouseId,
      userId: this.user.id,
    }).subscribe(data => {
      if (!this.errorService.manageError(data)) {
        this.loadData();
        this.cancelEdit(transportSheet.id);
      }
    });
  }

  onDisableTransportSheet(transportSheet: ITransportSheet) {
    const confirmationModal = this.modalService.open(ConfirmationModalComponent, {size: 'lg'});
    confirmationModal.componentInstance.confirmationDesc =
      `Désactiver définitivement l'étiquette ${transportSheet.ref} ? Cette action est irréversible.`;
    confirmationModal.componentInstance.validateButtonText = 'Désactiver';
    confirmationModal.componentInstance.cancelButtonText = 'Annuler';
    confirmationModal.result
      .then(result => {
        if (result) {
          this.apiLavandierService.putTransportSheetIdDisable(transportSheet.id, {})
            .subscribe(data => {
              if (!this.errorService.manageError(data)) {
                this.loadData();
              }
            });
        }
      })
      .catch(() => null);
  }

  cancelEdit(transportSheetId?: number) {
    if (transportSheetId !== undefined) {
      this.editingTransportSheets.delete(transportSheetId);
    } else {
      this.editingTransportSheets.clear();
    }
  }
}
